import React from 'react';
import cn from 'classnames';
import { isNil } from 'lodash';

import Space from 'components/generic/Space.component';
import S from 'constants/string.const';
import hasReactChildren from 'utils/react/hasReactChildren.util';
import parsfixed from 'utils/values/parsfixed.util';

import CN from './PosReaderPriceLine.module.scss';

const DT = Object.freeze({
  abs: 'absolute',
  pct: 'percentage',
});

const PosReaderPriceLine = ({ quantity, price, description, total, discount, discountType, children }) => {
  const shouldShowQuantity = quantity > 1;
  const shouldShowDiscount = discount > 0;
  const shouldShowPrice = !isNil(price);

  const isAbsolute = !discountType || discountType === DT.abs;
  const isPercentage = discountType === DT.pct;

  const discountPrefix = isAbsolute ? S.pound + S.nbsp : '';
  const discountSuffix = isPercentage && !isAbsolute ? S.nbsp + S.percent : '';

  const discountClasses = cn({
    [CN.discount]: true,
    [CN.abs]: isAbsolute,
    [CN.pct]: isPercentage && !isAbsolute,
  });

  const displayTotal = Number.isFinite(total) ? S.pound + S.nbsp + parsfixed(total) : '---';

  return (
    <div data-bem="PosReaderPriceLine" className={CN.component}>
      <p data-bem="PosReaderPriceLine__top-row" className={CN.row}>
        <div data-bem="PosReaderPriceLine__begin" className={CN.begin}>
          <span data-bem="PosReaderPriceLine__description" className={CN.description}>
            {description}
          </span>

          <span data-bem="PosReaderPriceLine__quantity" className={CN.quantity}>
            {shouldShowQuantity && <Space>{S.times + S.nbsp + quantity}</Space>}
          </span>
        </div>

        <div data-bem="PosReaderPriceLine__end" className={CN.end}>
          <span data-bem="PosReaderPriceLine__price" className={CN.price}>
            {shouldShowPrice && <Space>{S.pound + S.nbsp + parsfixed(price)}</Space>}
          </span>

          <span data-bem="PosReaderPriceLine__discount" className={discountClasses}>
            {shouldShowDiscount && (
              <Space>{S.minus + S.nbsp + discountPrefix + parsfixed(discount) + discountSuffix}</Space>
            )}
          </span>

          <span data-bem="PosReaderPriceLine__total" className={CN.total}>
            <Space>{displayTotal}</Space>
          </span>
        </div>
      </p>

      {hasReactChildren(children) && (
        <p data-bem="PosReaderPriceLine__bottom-row" className={CN.row}>
          {children}
        </p>
      )}
    </div>
  );
};

// noinspection JSUnusedGlobalSymbols
export default PosReaderPriceLine;
